var React = require('react');

function ArrowMRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"730E5F07-68E7-4B45-B173-6CAAE6619A62"),React.createElement("g",{"id":"Landing","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"SpeakEasy---Landing---Details---Mobile","transform":"translate(-42.000000, -491.000000)","stroke":"#FFFFFF","strokeWidth":"5"},React.createElement("g",{"id":"Arrow_m","transform":"translate(45.000000, 493.000000)"},[React.createElement("line",{"x1":"21","y1":"21.5","x2":"269","y2":"21.5","id":"Path-8","key":0}),React.createElement("circle",{"id":"Oval","cx":"12","cy":"21","r":"12","key":1}),React.createElement("polyline",{"id":"Path-9","points":"249 -7.14012183e-15 270 21 249 42","key":2})])))]);
}

ArrowMRight.defaultProps = {"width":"277px","height":"46px","viewBox":"0 0 277 46","version":"1.1"};

module.exports = ArrowMRight;

ArrowMRight.default = ArrowMRight;
